import areProductsLoadedByMemberIdSquadSelector from 'modules/squad/redux/selectors/are-products-loaded-by-member-id'
import { SQUAD_FILTER_TYPE } from 'modules/squad/redux/constants'
import getMemberProductsByIdAndFilterTypeSquadSelector from 'modules/squad/redux/selectors/get-member-products-by-id-and-filter-type'

const hasLoadedAllProductsOrHasProductsByMemberIdSquadSelector = memberId => state => {
  return !!(
    (
      areProductsLoadedByMemberIdSquadSelector(memberId, SQUAD_FILTER_TYPE.super_like)(state) ||
      getMemberProductsByIdAndFilterTypeSquadSelector(memberId, SQUAD_FILTER_TYPE.super_like)(state)?.total_product_count
    ) &&
    (
      areProductsLoadedByMemberIdSquadSelector(memberId, SQUAD_FILTER_TYPE.like)(state) ||
      getMemberProductsByIdAndFilterTypeSquadSelector(memberId, SQUAD_FILTER_TYPE.like)(state)?.total_product_count
    )
  )
}

export default hasLoadedAllProductsOrHasProductsByMemberIdSquadSelector
